import type { DesignVariant } from '@/platform/theme/appearance';

export function ThemePreview({ variant, dark }: { variant: DesignVariant; dark: boolean }) {
  return (
    <div
      aria-hidden="true"
      data-variant={variant}
      className={
        dark ? 'appearance-preview dark rounded-md p-2' : 'appearance-preview rounded-md p-2'
      }
      style={{ background: 'var(--background)', border: '1px solid var(--border)' }}
    >
      <div
        style={{
          background: 'var(--card)',
          color: 'var(--foreground)',
          border: '1px solid var(--border)',
          borderRadius: '0.375rem',
          padding: '0.5rem',
        }}
      >
        <p style={{ margin: 0, fontSize: '0.75rem' }}>Vorschau</p>
        <div style={{ display: 'flex', gap: '0.25rem', marginTop: '0.375rem' }}>
          <span
            style={{
              background: 'var(--primary)',
              color: 'var(--primary-foreground)',
              borderRadius: '0.25rem',
              fontSize: '0.75rem',
              padding: '0.125rem 0.5rem',
            }}
          >
            Aktion
          </span>
          <span
            style={{
              background: 'var(--destructive)',
              color: 'var(--destructive-foreground)',
              borderRadius: '0.25rem',
              fontSize: '0.75rem',
              padding: '0.125rem 0.5rem',
            }}
          >
            Stopp
          </span>
        </div>
      </div>
    </div>
  );
}
